import React from 'react';

import {
  Section,
  Container,
  Title,
  Description,
  TextContainer
} from './styles';

import { Unit } from '../../../../models/Unit';
import { UnitCard } from './components/Card';

import Slider, { CustomArrowProps } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './custom-slick.css';

const BackIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/Back/icon@2x.png';
const NextIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/Next/icon@2x.png';

type Props = {
  listUnits: Unit[] | undefined;
  onClickSeeDetails: (unit: Unit) => void;
};

const SlickArrowRight = ({ onClick, className }: CustomArrowProps) => (
  <img
    className={className}
    src={NextIcon}
    alt="next-arrow"
    onClick={onClick}
  />
);

const SlickArrowLeft = ({ onClick, className }: CustomArrowProps) => (
  <img
    className={className}
    src={BackIcon}
    alt="back-arrow"
    onClick={onClick}
  />
);

const Units = ({ listUnits, onClickSeeDetails }: Props) => {
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };

  return (
    <Section id="unidades">
      <Container>
        <TextContainer>
          <Title>Unidades de Atendimento</Title>
          <Description>
            Clique{' '}
            <a
              href="https://www.einstein.br/estrutura/unidades"
              target="_blank"
              rel="noreferrer"
            >
              aqui
            </a>{' '}
            e confira os horários específicos de cada serviço ou tempo de espera
            do Pronto Atendimento.
          </Description>
        </TextContainer>
        <Slider
          className="carousel-slick"
          dotsClass="custom-slick-dots"
          {...settings}
        >
          {listUnits?.map(unit => {
            if (unit.active) {
              return (
                <UnitCard
                  key={unit.id}
                  imgSrc={unit.img_url || undefined}
                  title={unit.name}
                  subtitle={[
                    `${unit.address}, ${unit.address_number}`,
                    `${unit.neighborhood}, ${unit.city} - ${unit.state}`
                  ]}
                  onClickSeeDetails={() => onClickSeeDetails(unit)}
                />
              );
            }
            return null;
          })}
        </Slider>
      </Container>
    </Section>
  );
};

export default Units;
